import React, {CSSProperties, useEffect, useState} from 'react';
import { Card } from '../card';
import styles from './ListingCard.module.css';
import { ListingDetails } from '../listing-details';
import { Agency, Listing } from '../../../api/shared/types';

interface ListingCardProps {
    readonly listing?: Listing;
    readonly agency?: Agency;
}

const ListingCard = ({
    listing,
    agency,
}: ListingCardProps) => {
    const [ isLogoValid, setIsLogoValid ] = useState<boolean | undefined>(undefined);
    const [listingImageStyleAttr, setListingImageStyleAttr] = useState<CSSProperties| undefined>(undefined);

    useEffect(() => {
        if (listing && listing.imageUrl) {
            checkImageValidity(listing.imageUrl).then((isValid) => {
                if (isValid) {
                    setListingImageStyleAttr({ backgroundImage: `url('${listing.imageUrl}')` });
                }
            });
        }
        if (agency && agency.logo) {
            checkImageValidity(agency.logo).then(setIsLogoValid);
        }
    }, [listing, agency]);

    const checkImageValidity = (imageUrl: string) => {
        return new Promise<boolean>((resolve) => {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
        });
    }

    return (
        <Card
            elevated
            hasPadding={false}
        >
            <div>
                {listingImageStyleAttr &&
                    <div
                        className={styles.image}
                        style={listingImageStyleAttr}
                    ></div>
                }
                <div style={{ padding: '16px' }}>
                    {listing &&
                        <ListingDetails
                            street={listing.street}
                            houseNumber={listing.houseNumber}
                            postalCode={listing.postalCode}
                            city={listing.city}
                            price={listing.price}
                            surface={listing.surface}
                            rooms={listing.rooms}
                        />
                    }
                </div>
                {(isLogoValid && agency) &&
                    <div className={styles.agencyLogo}>
                        <img
                            src={agency.logo}
                            alt="Logo van de makelaar"
                        />
                    </div>
                }
            </div>
        </Card>
    );
};

export default ListingCard;
